import React, { useState } from 'react';
import { bindActionCreators, Dispatch } from '@tkit/actions';
import { analysisScore, analysisImg } from '@src/utils/constant/level';
import { APIS, DetailsTargetUserInfo } from '@src/services';
import { SFCAvatar } from '@features/common';
import { ShowInfo, Medal } from '@features/common/components';
import { connect } from 'react-redux';
import { message, Popover } from 'antd';
import { IRootState } from 'src/types';
import actions from '../redux/actions';
import './PersonCard.less';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & IPersonCardProps;

export interface IPersonCardProps {
  photo?: string;
  username: string;
  className?: string;
  /** 关注之后的回调函数 */
  follow?: () => void;
}

export function PersonCard(props: Readonly<Props>) {
  const {
    className = '',
    photo,
    username,
    follow,
    actions: { userFollow }
  } = props;
  const [loaded, setLoaded] = useState(false);
  const [noticeTxt, setNoticeTxt] = useState('已关注');
  const [userDetal, setUserDetail] = useState<DetailsTargetUserInfo>({});

  const { level } = analysisScore(userDetal.point || 0);
  const { haveList: ImgList } = analysisImg(level);

  const initUserData = () => {
    if (!loaded) {
      setLoaded(true);
      APIS.UserApi.userDetailsUsingGet({ targetUser: username }).then(res => {
        if (res.code === 0 && res.result) {
          setUserDetail(res.result);
        }
      });
    }
  };

  const onEnter = () => {
    setNoticeTxt('取消关注');
  };

  const onLeave = () => {
    setNoticeTxt('已关注');
  };

  const handleFollow = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const ifFollow = !userDetal.followed;

    userFollow({
      params: { ifFollow, targetUser: username },
      callBack: () => {
        setUserDetail(pre => ({
          ...pre,
          followed: ifFollow
        }));
        follow && follow();
        message.success('操作成功');
      }
    });
  };

  return (
    <div className={`common-presenter k-common-person-card ${className}`}>
      <Popover
        trigger="click"
        title={null}
        placement="bottomLeft"
        overlayClassName="k-common-inner-card__con"
        content={
          <>
            <div className="card__top">
              <SFCAvatar className="con__photo" src={userDetal.photo} />
              <div className="card__right">
                <div className="card__name-btn">
                  <h3 className="card__name">{userDetal.name}</h3>
                  {!userDetal.self && (
                    <>
                      {userDetal.followed ? (
                        <div
                          className="card__btn"
                          onClick={handleFollow}
                          onMouseEnter={onEnter}
                          onMouseLeave={onLeave}
                        >
                          {noticeTxt}
                        </div>
                      ) : (
                        <div onClick={handleFollow} className="card__btn">
                          关注
                        </div>
                      )}
                    </>
                  )}
                </div>
                <ShowInfo
                  list={[
                    {
                      icon: 'icon-peo',
                      num: userDetal.followedNum || 0,
                      des: '个粉丝'
                    },
                    {
                      icon: 'icon-article',
                      num: userDetal.articleNum || 0,
                      des: '篇文章'
                    }
                  ]}
                />
              </div>
            </div>
            <div className={userDetal?.profile?.trim() ? 'card__desc' : 'card__desc none'}>
              {userDetal?.profile?.trim() || '暂无简介'}
            </div>
            <div className="mdeal-list">
              {ImgList.map((item, index) => (
                <Medal key={index} className="medal-item" img={item?.img} />
              ))}
            </div>
          </>
        }
      >
        <SFCAvatar className="default__size" src={photo} onClick={initUserData} />
      </Popover>
    </div>
  );
}

/* istanbul ignore next */
function mapStateToProps(state: IRootState /*, ownProps: IPersonCardProps*/) {
  return {
    baseUserPointInfo: state.common.baseUserPointInfo
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch: Dispatch /*, ownProps: IPersonCardProps*/) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect<StateProps, DispatchProps, IPersonCardProps>(
  mapStateToProps,
  mapDispatchToProps
)(PersonCard);
